import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, switchMap } from "rxjs/operators";
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private userService: UserService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    var oldLocal = localStorage.getItem('localUser');
    var itemLocal = JSON.parse(oldLocal);
    if (!itemLocal) return next.handle(request);

    const accessToken = itemLocal.accessToken;
    const refresh_token = itemLocal.refresh_token;
    if (!accessToken) return next.handle(request);

    request = request.clone({
      setHeaders: {
        'Authorization': `Bearer ${accessToken}`
      }
    });
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!(error.status === 401 || error.status === 403)) return throwError(error);

        localStorage.removeItem('localUser');
        return this.userService.refreshToken(refresh_token).pipe(
          switchMap(() => {
            var oldLocal = localStorage.getItem('localUser');
            var itemLocal = JSON.parse(oldLocal);
            if (itemLocal && itemLocal.accessToken) request = request.clone({
              setHeaders: {
                'Authorization': `Bearer ${itemLocal.accessToken}`
              }
            });

            return next.handle(request).pipe(
              catchError((error: HttpErrorResponse) => {
                this.router.navigate(['/errorPage']);
                return throwError(error);
              })
            )
          })
        );
      })
    );
  }

}
